import { render } from "./MatchDashboard.vue?vue&type=template&id=13b1cc1b&scoped=true"
import script from "./MatchDashboard.vue?vue&type=script&lang=js"
export * from "./MatchDashboard.vue?vue&type=script&lang=js"

import "./MatchDashboard.vue?vue&type=style&index=0&id=13b1cc1b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b1cc1b"]])

export default __exports__